module.exports = __webpack_public_path__ + "static/img/img-cp2.bd7d11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp2.png
// module id = YRDe
// module chunks = 0